import React from "react";
import "@/App.css";
import { BrowserRouter, HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/AuthContext";
import { I18nProvider } from "@/lib/i18n";
import SmoothScroll from "@/lib/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ReplyPage from "@/pages/ReplyPage";

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
    <WhatsAppFloat />
  </>
);

const Layout = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  const isReply = pathname.startsWith("/reply");
  return (
    <Routes>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/reply/:token" element={<ReplyPage />} />
      <Route
        path="/*"
        element={
          isAdmin || isReply ? null : (
            <PublicLayout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/catalogue" element={<Catalogue />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </PublicLayout>
          )
        }
      />
    </Routes>
  );
};

const Router = process.env.REACT_APP_LOCAL_PREVIEW === "true" ? HashRouter : BrowserRouter;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <I18nProvider>
          <SmoothScroll>
            <Router>
              <Layout />
            </Router>
          </SmoothScroll>
        </I18nProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
